import { createActionCreator } from "deox";
import { IBrokerageAnniversaryModel } from "../../../types/types";

// Loading states
export const brokerageAnniversariesLoading = createActionCreator(
  "financialSettings/brokerageAnniversaries/loading"
);
export const brokerageAnniversariesLoaded = createActionCreator(
  "financialSettings/brokerageAnniversaries/loaded",
  (resolve) => (payload: IBrokerageAnniversaryModel[]) => resolve(payload)
);
export const brokerageAnniversariesError = createActionCreator(
  "financialSettings/brokerageAnniversaries/error",
  (resolve) => (error: string) => resolve(error)
);

// Create brokerage anniversary
export const createBrokerageAnniversaryPending = createActionCreator(
  "financialSettings/createBrokerageAnniversary/pending"
);
export const createBrokerageAnniversaryFulfilled = createActionCreator(
  "financialSettings/createBrokerageAnniversary/fulfilled",
  (resolve) => (payload: IBrokerageAnniversaryModel) => resolve(payload)
);
export const createBrokerageAnniversaryRejected = createActionCreator(
  "financialSettings/createBrokerageAnniversary/rejected",
  (resolve) => (error: string) => resolve(error)
);

// Update brokerage anniversary
export const updateBrokerageAnniversaryPending = createActionCreator(
  "financialSettings/updateBrokerageAnniversary/pending",
  (resolve) => (id: number) => resolve(id)
);
export const updateBrokerageAnniversaryFulfilled = createActionCreator(
  "financialSettings/updateBrokerageAnniversary/fulfilled",
  (resolve) => (payload: IBrokerageAnniversaryModel) => resolve(payload)
);
export const updateBrokerageAnniversaryRejected = createActionCreator(
  "financialSettings/updateBrokerageAnniversary/rejected",
  (resolve) => (error: string) => resolve(error)
);

// Delete brokerage anniversary
export const deleteBrokerageAnniversaryPending = createActionCreator(
  "financialSettings/deleteBrokerageAnniversary/pending",
  (resolve) => (id: number) => resolve(id)
);
export const deleteBrokerageAnniversaryFulfilled = createActionCreator(
  "financialSettings/deleteBrokerageAnniversary/fulfilled",
  (resolve) => (id: number) => resolve(id)
);
export const deleteBrokerageAnniversaryRejected = createActionCreator(
  "financialSettings/deleteBrokerageAnniversary/rejected",
  (resolve) => (error: string) => resolve(error)
);

// Get active brokerage anniversary for date
export const activeBrokerageAnniversaryLoading = createActionCreator(
  "financialSettings/activeBrokerageAnniversary/loading"
);
export const activeBrokerageAnniversaryLoaded = createActionCreator(
  "financialSettings/activeBrokerageAnniversary/loaded",
  (resolve) => (payload: IBrokerageAnniversaryModel) => resolve(payload)
);
export const activeBrokerageAnniversaryError = createActionCreator(
  "financialSettings/activeBrokerageAnniversary/error",
  (resolve) => (error: string) => resolve(error)
);

// Clear errors
export const clearFinancialSettingsErrors = createActionCreator(
  "financialSettings/clearErrors"
);
